export const sendMessage = (callbackName: NativeBridgeCallbackName, value?: string) => {
  const messageHandler = window.webkit?.messageHandlers[callbackName];

  if (messageHandler) {
    // eslint-disable-next-line unicorn/require-post-message-target-origin -- Native message handler, not `window.postMessage`
    messageHandler.postMessage(value);
  }

  if (typeof JSBridge !== 'undefined') {
    JSBridge[callbackName]?.(value);
  }
};
